import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';

import {
    withStyles, Typography,
} from '@material-ui/core';

import urls from '../../../app/urls';
import { TrackedLink } from '../../../common/components';
import { activityLabels } from '../../../common/constants';

const styles = theme => ({
    root: {
        background: theme.palette.grey[100],
        padding: theme.spacing(2, 4),
    },
    topContainer: {
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 500,
        borderLeft: theme.youwell.borders.secondary,
        borderLeftWidth: 4,
        paddingLeft: theme.spacing(2),
    },
    description: {
        marginBottom: theme.spacing(4),
    },
    content: {
    },
    linkWrapper: {},
    linkButton: {
        display: 'inline-block',
        padding: theme.spacing(0, 1),
        marginBottom: theme.spacing(2),
        borderBottom: theme.youwell.borders.secondary,

        '&:hover': {
            borderColor: theme.youwell.colors.black,
        },
    },
    linkButtonText: {
        lineHeight: 1,
    },
});

class ScheduledTasksBox extends React.Component {
    render() {
        const {
            classes, translate, className, elements,
        } = this.props;

        if (!elements || elements.length === 0) {
            return null;
        }

        return (
            <div className={classnames(classes.root, className)}>
                <div className={classes.topContainer}>
                    <Typography variant="h6" className={classes.title}>
                        {translate('dashboard.scheduledTasks')}
                    </Typography>
                    <Typography className={classes.description}>
                        {translate('dashboard.scheduledTasksDescription')}
                    </Typography>
                </div>
                <div className={classes.content}>
                    {elements.map((element, index) => (
                        <div key={element.id} className={classes.linkWrapper}>
                            <TrackedLink
                                className={classes.linkButton}
                                to={`${urls.inside.program}/${element.elementGroup}/${element.indexInGroup}/${urls.inside.parts.resumeLatest}`}
                                label={`${activityLabels.dashboard.questionnaires}/${index}`}
                            >
                                <Typography variant="button" className={classes.linkButtonText}>
                                    {element.name}
                                </Typography>
                            </TrackedLink>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

ScheduledTasksBox.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    elements: PropTypes.array.isRequired,
    className: PropTypes.string,
};

ScheduledTasksBox.defaultProps = {
    className: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(ScheduledTasksBox));
